export class Promotion {

  public promoCode: string;
  public promoCodeMessage: string;

  constructor(promoCode: string, promoCodeMessage: string) {
    this.promoCode = promoCode;
    this.promoCodeMessage = promoCodeMessage;
  }
}
